import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import "./Experiencias.css";

function Experiencias({ id }) {
  const [experiences, setExperiences] = useState([]);
  const [currentExperienceIndex, setCurrentExperienceIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'experiences'));
        const experiencesList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setExperiences(experiencesList);
      } catch (error) {
        console.error('Error fetching experiences:', error);
      }
    };

    fetchExperiences();
  }, []);

  useEffect(() => {
    if (experiences.length > 0) {
      const interval = setInterval(() => {
        setCurrentExperienceIndex((prevIndex) =>
          (prevIndex + 1) % experiences.length
        );
      }, 8000); // Change experience every 8 seconds

      return () => clearInterval(interval);
    }
  }, [experiences]);

  const handleExploreClick = () => {
    navigate('/experiencias'); // Navigate to the dedicated experiences page
  };

  if (experiences.length === 0) {
    return <section id={id} className="experiencias-section">Cargando experiencias...</section>;
  }

  const currentExperience = experiences[currentExperienceIndex];

  const renderMedia = () => {
    const { mediaType, imageUrl, videoUrl, id, title } = currentExperience;
    const url = imageUrl || videoUrl;

    if (!url) {
        return <div className="experience-video" />;
    }

    const isImage = mediaType === 'image' || (!mediaType && /\.(jpg|jpeg|png|gif)$/i.test(url));

    if (isImage) {
        return <img key={id} src={url} alt={title} className="experience-image" />;
    } else {
        return (
            <video key={id} autoPlay loop muted playsInline className="experience-video">
                <source src={url} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    }
  };

  const textPanelStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url('/fondosedes.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white'
  };

  return (
    <section id={id} className="experiencias-section">
      <div className="video-panel">
        {renderMedia()}
      </div>
      <div className="text-panel" style={textPanelStyle}>
        <div key={currentExperience.id} className="text-content animated-text">
          <h2>{currentExperience.title}</h2>
          <p>{currentExperience.description}</p>
          <button className="explore-button" onClick={handleExploreClick}>Explorar Experiencias</button>
        </div>
      </div>
    </section>
  );
}

export default Experiencias;